import React from 'react'
import { useTranslation } from 'react-i18next'
import ActivityLoadingPane from './ActivityLoadingPane'
import { getActivityBackground } from './activityBackgrounds'
import { getCoverLabel } from './activityCoverLabel'
import getIsTWAMode from '../helpers/twaMode'

/**
 * Whether this route has a hold to show — an activity with a registered color, inside the Together app.
 */
export function hasActivityCover() {
  return getIsTWAMode() && getActivityBackground(window.location.pathname) !== null
}

/**
 * Stands in for a spinner and holds one colored background while an activity loads inside the Together app,
 * for smoother loading.
 *
 * Renders nothing on a route with no color registered. Callers should ask hasActivityCover() first, so
 * they can keep their own indicator instead.
 */
export default function ActivityCover() {
  const { t } = useTranslation()
  const background = getActivityBackground(window.location.pathname)

  if (!background) {
    return null
  }

  return <ActivityLoadingPane background={background} label={getCoverLabel() ?? t('shared.loading', 'Loading')} />
}
